import { render, staticRenderFns } from "./QuickTourCardWrapper.vue?vue&type=template&id=485348d6&scoped=true"
import script from "./QuickTourCardWrapper.vue?vue&type=script&lang=js"
export * from "./QuickTourCardWrapper.vue?vue&type=script&lang=js"
import style0 from "./QuickTourCardWrapper.vue?vue&type=style&index=0&id=485348d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485348d6",
  null
  
)

export default component.exports